export default {"src":"/_next/static/image/public/images/packageCardDefault.beca833338dc49beea8155fb96f6a225.svg","height":140,"width":251};